<kendo-dialog *ngIf="dialogOpened" id="taskAssigneeDialog" title="{{'ASSIGN-TASK' | translate}}: {{shortTaskName}}"
  (close)="closeDialog()" [height]="300" [minWidth]="200" [width]="500">
  <form class="k-form-inline p-2">
    <label class="k-form-field">
      <span class="k-text-uppercase dark" style="min-width:35%">{{ 'ASSIGNEE' | translate }} *</span>
      <kendo-combobox required [data]="staffFiltered" [(ngModel)]="assignee" [ngModelOptions]="{standalone: true}"
        [textField]="'name'" [valueField]="'username'" [filterable]="true" (filterChange)="staffFilter($event)"
        [itemDisabled]="itemDisabled" (close)="searchTerm=''" [placeholder]="'TYPE-OR-SELECT' | translate"
        style="width: 100%">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
          </span>
        </ng-template>
      </kendo-combobox>
    </label>
  </form>
  <div style="position:absolute;bottom:15px;">* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeDialog()">{{'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton (click)="assign();"
      [disabled]="!assignee || (assignee && !assignee.name)">{{'SAVE' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>